const layout = () => import("../../internal/layout.vue");
const consultExams = () => import("./consultExams.vue");
const visualizarLaudo = () => import("./visualizarLaudo.vue");

const consultExamsRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "consultExams",
      meta: {
        title: "CONSULTAR EXAMES",
        requiresAuth: true,
      },
      component: consultExams,
    },
    {
      path: "visualizar-laudo",
      name: "visualizarLaudo",
      meta: {
        title: "VISUALIZAR LAUDO",
        requiresAuth: true,
      },
      component: visualizarLaudo,
    },
  ],
};

export default consultExamsRoutes;
